import { gql } from '@apollo/client'
import { SABRE_FLAVOR_FRAGMENT } from '../fragments'

export const SABRE_CREATE_PRODUCT_FLAVOR = gql`
  mutation CreateFlavor($input: CreateFlavorInput!) {
    createFlavor(input: $input) {
      flavor {
        ...Flavor
      }
    }
  }
  ${SABRE_FLAVOR_FRAGMENT}
`
